import { styled } from '@creditas/stylitas'

const ContainerImage = styled.div`
  display: flex;
  padding: 19px 25px;
  border-radius: 10px;
  background-color: white;
  box-shadow: 0px 11.083333015441895px 25.33333396911621px 0px
    rgba(31, 45, 39, 0.16);
  max-width: 190px;
  margin: auto;
`

const Image = styled.img`
  display: block;
  max-width: 100%
`

export { ContainerImage, Image }
